import React from 'react';
import styled from '@emotion/styled';

const Caution = styled.h1({
    minHeight: '45px',
    fontSize: '40px',
    fontWeight: 'normal',
    color: '#193340',
    padding: '20px',
    margin: 0,
});

export type CautionTextProps = {
    text: string;
}

export const CautionText = (props: CautionTextProps) => {
    return (
        <Caution>{props.text}</Caution>
    );
};
